import { render, staticRenderFns } from "./Edition.vue?vue&type=template&id=1f9c599d&scoped=true&"
import script from "./Edition.vue?vue&type=script&lang=js&"
export * from "./Edition.vue?vue&type=script&lang=js&"
import style0 from "./Edition.vue?vue&type=style&index=0&id=1f9c599d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9c599d",
  null
  
)

export default component.exports